<template>
  <div>
        <el-tabs class="tabs" v-model="activeName"  type="card" @tab-click="handleClick">
            <el-tab-pane label="当前重点任务" name="当前重点任务">
                <el-table :data="itemlist" border style="width:100%" :height="hh+20" stripe size="mini">
                    <el-table-column prop="unit_name" label="任务发起人" width="120" align="center"></el-table-column>
                    <el-table-column prop="spe_type" label="任务类型" width="150"></el-table-column>
                    <el-table-column prop="spe_name" label="任务名称" width="260"></el-table-column>                    
                    <el-table-column prop="spe_desc" label="任务描述"></el-table-column>
                    <el-table-column prop="spe_edate" label="截止时间" width="140"></el-table-column>
                    <el-table-column label="已报送数量" width="90" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.file_count_push>0 ?'success':'danger'">{{ scope.row. file_count_push}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="95">
                        <template slot-scope="scope">
                            <el-button @click="change(scope)" type="danger" size="mini">报送材料</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- <el-pagination style="text-align:left;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 30, 40, 200]" :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper" :total="rt">
                </el-pagination> -->
            </el-tab-pane>
            <el-tab-pane label="报送过的材料" name="报送过的材料">
                <div class="pagelist" :style="{ height: hh + 'px' }">
                                <div class="listitem" v-for="item in itemlistpush" :key="item.file_id">
                                    <div>
                                        <el-image style="width:130px;height:130px" :src="item.file_surl" :preview-src-list="getitems(item.file_url,',')"></el-image>
                                        <div style="text-align: center;">
                                            {{ item.file_name }}<br/>
                                            {{ item.new_title }}
                                        </div>
                                    </div>
                                </div>
                </div>
                <el-pagination style="text-align:left;" @size-change="handleSizeChangepush" @current-change="handleCurrentChangepush"
                    :current-page="currentPagepush" :page-sizes="[10, 20, 30, 40, 200]" :page-size="pagesizepush"
                    layout="total, sizes, prev, pager, next, jumper" :total="rtpush">
                </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="采纳过的材料" name="采纳过的材料">
                <div class="pagelist" :style="{ height: hh + 'px' }">
                                <div class="listitem" v-for="item in itemlisttakein" :key="item.file_id">
                                    <div>
                                        <el-image style="width:130px;height:130px" :src="item.file_surl" :preview-src-list="getitems(item.file_url,',')"></el-image>
                                        <div style="text-align: center;">
                                            {{ item.file_name }}<br/>
                                            {{ item.new_title }}
                                        </div>
                                    </div>
                                </div>
                </div>
                <el-pagination style="text-align:left;" @size-change="handleSizeChangetakein" @current-change="handleCurrentChangetakein"
                    :current-page="currentPagetakein" :page-sizes="[10, 20, 30, 40, 200]" :page-size="pagesizetakein"
                    layout="total, sizes, prev, pager, next, jumper" :total="rttakein">
                </el-pagination>
            </el-tab-pane>
        </el-tabs>
        
        <el-dialog :title="itemedit.spe_name" width="90%" :visible.sync="dialogFormVisible" v-dialogDrag>
            <el-descriptions title="" :column="3" border size="mini" :labelStyle="{width:'80px',textAlign: 'center'}">
                <el-descriptions-item label="任务类型">
                    <el-tag size="small">{{ itemedit.spe_type }}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="提交周期">{{ itemedit.spe_bdate }}至{{ itemedit.spe_edate }}</el-descriptions-item>
                <el-descriptions-item label="制定日期">{{ itemedit.spe_date }}</el-descriptions-item>
                <el-descriptions-item label="任务描述" :span="3">{{ itemedit.spe_desc }}</el-descriptions-item>
            </el-descriptions>
            <el-tabs v-model="activeName2" type="border-card">
                <el-tab-pane label="已经报送了的材料" name="已经报送了的材料">
                    <div class="pagelist">
                        <div class="listitem" v-for="(item,index) in pushlist" :key="item.new_id">
                                    <div>
                                        <el-image :src="getfirstitem(item.file_surls_push,',')"  :preview-src-list="getitems(item.file_urls_push,',')" style="width:130px;height:130px;"></el-image>
                                            <div style="text-align: center;">
                                                {{item.unit_name}}<br />
                                                {{item.new_title}}
                                            </div>
                                        </div>
                                        <div class="countitem">
                                            <span class="countitem1">{{ item.file_count_push }}</span>
                                            <span class="countitem2">{{ item.file_count }}</span>
                                        </div>
                                        <div class="deleteitem">
                                            <i class="el-icon-edit-outline" title="重新选取" style="font-size: 25px; color: #c0c4cc"
                                                @click="changefiles(item.new_id,item.new_title,item.unit_id,item.unit_name,2)"></i>
                                            <i class="el-icon-circle-close" title="去除此材料" style="font-size: 25px; color: #c0c4cc"
                                                @click="DelPush(item, index)"></i>
                                        </div>
                                </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="搜索本系统内的材料报送" name="搜索本系统内的材料报送">
                        <div style="display:flex;flex-direction: row;">
                                
                        <div class="pagelist">
                                        <div class="listitem" v-for="item in newsquerylist" :key="item.new_id">
                                            <div @click="changefiles(item.new_id, item.new_title, item.unit_id, item.unit_name, 3)">
                                                <img :src="getfirstitem(item.file_surls, ',')">
                                                <div style="text-align: center;">
                                                    {{ item.unit_name }}<br />
                                                    {{ item.new_title }}
                                                </div>
                                            </div>
                                            <div class="countitem">
                                                <!-- <span class="countitem1">{{ item.file_count_takein }}</span> -->
                                                <span class="countitem2">{{ item.file_count }}</span>
                                            </div>
                                        
                                            <!-- <div class="deleteitem">
                                            <i class="el-icon-circle-check" title="遴选此材料" style="font-size: 25px; color: #c0c4cc"
                                                @click="editimage(drag, index)"></i>
                                        </div> -->
                                        </div>
                                    </div>
                                    <div style="width:330px;padding-right:5px;">
                            <el-descriptions border label="在系统中查找我的材料" size="mini" :columns="3" :labelStyle="{ width: '100px' }">
                                    <el-descriptions-item :span="3" :labelStyle="{ width: '80px' }">
                                            <template slot="label">活动周期</template>
                                            <el-date-picker type="date" v-model="newsquerypar.bdate" style="width:160px" placeholder="选择开始日期" size="mini" @input="inputmethod()"></el-date-picker>
                                        </el-descriptions-item>
                                        <el-descriptions-item :span="3">
                                            <template slot="label">至</template>
                                            <el-date-picker type="date" v-model="newsquerypar.edate" style="width:160px" placeholder="选择开始日期" size="mini" @input="inputmethod()"></el-date-picker>
                                        </el-descriptions-item>
                                        <el-descriptions-item :span="3">
                                            <template slot="label">关键词</template>
                                            <el-input size="mini" v-model="newsquerypar.keywords" placeholder="多个关键词用“,”隔开" @input="inputmethod()"></el-input>
                                        </el-descriptions-item>
                                    <el-descriptions-item :span="3">
                                            <template slot="label">搜索方式</template>
                                            <el-select v-model="newsquerypar.querymode" size="mini" style="width:160px;">
                                                <el-option label="包含一个关键词" value="0"></el-option>
                                                <el-option label="包含全部关键词" value="1"></el-option>
                                            </el-select>
                                        </el-descriptions-item>
                                        <el-descriptions-item :span="3">
                                            <template slot="label">返回数据量</template>
                                            <el-input-number size="mini" v-model="newsquerypar.showcount"></el-input-number>
                                        </el-descriptions-item>
                                </el-descriptions>
                                <div style="margin: 5px;width:auto;" ><el-button type="danger" style="width:100%;" @click="newsquery()">搜索</el-button></div> 
                        </div>
                                </div>
                    </el-tab-pane>
            </el-tabs>
        </el-dialog>
        <el-dialog :title="'['+news.unit_name+']'+news.new_title" :visible="dialogFormVisible4" width="70%" :show-close="false" v-dialogDrag append-to-body>
            <el-tabs v-model="activeName1">
                <el-tab-pane label="图片列表" name="图片列表">
                    <div class="pagelist" :style="{ height: hh2 + 'px' }">
                                <div class="listitem" v-for="item in newsfiles" :key="item.file_id">
                                    <div>
                                        <el-image style="width:130px;height:130px" :src="item.file_surl" :preview-src-list="getitems(item.file_url,',')"></el-image>
                                        <div style="text-align: center;">
                                            {{ item.file_name }}
                                        </div>
                                    </div>
                                    <div class="deleteitem">
                                        <i v-if="item.pushed" class="el-icon-circle-check" title="去除此图片" style="font-size:25px;color:red" @click="pushchk(item,false)"></i>
                                        <i v-else  class="el-icon-circle-check" title="选取此图片" style="font-size:25px;color:#c0c4cc" @click="pushchk(item,true)"></i>
                                    </div>
                                </div>
                            </div>
                </el-tab-pane>
                <el-tab-pane label="材料详情" name="材料详情">
                    <iframe :src="'/api/newsshow?new_id='+news.new_id" style="border:1px solid #ccc;width:100%;height:350px;">

                    </iframe>
                </el-tab-pane>
            </el-tabs>
            <div slot="footer" class="dialog-footer">
                <querytitle>
                    <template slot="queryleft">
                        当前选定了<el-tag type="danger">{{newspushs.length}}</el-tag>张图片
                    </template>
                    <template slot="queryright">
                        <el-button @click="dialogFormVisible4 = false">取 消</el-button>
                        <el-button type="primary" @click="PostPush()">确 定</el-button>
                    </template>
                </querytitle>                
            </div>
        </el-dialog>
  </div>
</template>

<script>
import querytitle from '@/components/querytitle'
export default {
    components: {
        querytitle
    },
    data(){
        return {
            hh: 500,
            hh2: 350,
            loading: false,
            itemlist: [],
            itemindex: 0,
            itemedit: {},
            dialogFormVisible: false,
            rt: 0,
            currentPage: 1,
            pagesize: 10,

            itemlistpush:[],
            rtpush: 0,
            currentPagepush: 1,
            pagesizepush: 20,

            itemlisttakein:[],
            rttakein: 0,
            currentPagetakein: 1,
            pagesizetakein: 20,

            activeName:'当前重点任务',
            dialogFormVisible4:false,
            activeName2:'已经报送了的材料',
            //待选材料
            dialogFormVisible3: false,
            pushlist:[],//已报送材料
            newsquerylist:[],//系统内查找材料列表
            newsquerypar:{bdate:'',edate:'',keywords:'',querymode:'1',speid:'',showcount:100,selectmode:0},//搜索条件
            //文章内图片
            newsstate:1,//2：从单位报送材料打开，3：从系统查找材料打开
            dialogFormVisible4: false,
            activeName1:'图片列表',
            news:{},
            newsfiles:[],//文章图片列表
            newspushs:[],//已经报送的图片
            newstakeins:[]//已经选取的图片
        }
    },
    created(){
        this.hh = document.documentElement.clientHeight - 230;
        this.hh2 = this.hh - 200;
        this.getmainlist();
    },
    methods:{
        handleClick(e){
            switch(this.activeName){
                case "当前重点任务":
                    this.currentPage=1
                    this.getmainlist();
                    break;
                case "报送过的材料":
                    this.currentPagepush=1
                    this.getpushlist();
                    break;
                case "采纳过的材料":
                    this.currentPagetakein = 1
                    this.gettakeinlist()
                    break;
            }
        },
        getfirstitem(strlist,str){//获取字符串中的第一项
            var n = strlist.split(str);
            if(n.length>0)
                return n[0];
            else
                return "";
        },
        getitems(strlist,str){//字符串转数组
            let n = strlist.split(str);
            return n;
        },
        getmainlist() {
            let that = this
            that.GetData('Spe/SpeMyTask',{},function(res){
                that.itemlist = res.data.data;
            },function(err){
                that.$alert(err, { title: "错误" });
            })

            // let wherestring = [
            //     { field: 'spe_state', sym: '=', val: '确认', oper: 'and' },
            //     { field: 'unit_id', sym: 'like', val: this.CU.cu.orgid+'%', oper: 'and' },
            //     { field: 'spe_edate', sym: '>=', val: this.FormatDateTime(new Date()), oper: 'and (' },
            //     { field: 'spe_units', sym: 'like', val: '%'+this.CU.cu.orgid+'%', oper: 'or' },
            //     { field: 'spe_units', sym: 'is', val: 'null', oper: 'or' },
            //     { field: 'spe_units', sym: '=', val: '', oper: ')' },
            // ]
            // let pars = { objname: "spe_main", wheres: wherestring, PageSize: that.pagesize, CurrentPage: that.currentPage }
            // that.PostData("Common/GETLIST", pars, function (res) {
            //     that.itemlist = res.data.data;
            //     that.rt = res.data.rowTotal
            // }, function (err) {
            //     that.$alert(err, { title: "错误" });
            // }
            // );
        },
        handleCurrentChange(e) {
            this.currentPage = e;
            this.getmainlist()
        },
        handleSizeChange(e) {
            this.pagesize = e;
            this.getmainlist()
        },
        getpushlist() {
            let that = this
            let wherestring = [
                { field: 'unit_id', sym: '=', val: this.CU.cu.orgid, oper: 'and' }
            ]
            let pars = { objname: "spe_push", wheres: wherestring, PageSize: that.pagesizepush, CurrentPage: that.currentPagepush,orderbys:[{field:'spep_date',asc:'asc'}]}
            that.PostData("Common/GETLIST", pars, function (res) {
                that.itemlistpush = res.data.data;
                that.rtpush = res.data.rowTotal
            }, function (err) {
                that.$alert(err, { title: "错误" });
            }
            );
        },
        handleCurrentChangepush(e) {
            this.currentPagepush = e;
            this.getpushlist()
        },
        handleSizeChangepush(e) {
            this.pagesizepush = e;
            this.getpushlist()
        },
        gettakeinlist() {
            let that = this
            let wherestring = [
                { field: 'unit_id', sym: '=', val: this.CU.cu.orgid, oper: 'and' }
            ]
            let pars = { objname: "spe_takein", wheres: wherestring, PageSize: that.pagesizetakein, CurrentPage: that.currentPagetakein,orderbys:[{field:'spet_date',asc:'asc'}]}
            that.PostData("Common/GETLIST", pars, function (res) {
                that.itemlisttakein = res.data.data;
                that.rttakein = res.data.rowTotal
            }, function (err) {
                that.$alert(err, { title: "错误" });
            }
            );
        },
        handleCurrentChangetakein(e) {
            this.currentPagetakein = e;
            this.gettakeinlist()
        },
        handleSizeChangetakein(e) {
            this.pagesizetakein = e;
            this.gettakeinlist()
        },
        change(par) {//点击报送材料
            
            this.addflag = false;
            this.itemindex = par.$index;
            this.itemedit = par.row//Object.assign({}, par.row);
            let that = this
            that.activeName2 = "已经报送了的材料";
            that.pushlist = []
            that.GetData('Spe/SpePushList',{speid:that.itemedit.spe_id,selectmode:3},function(res){
                that.pushlist = res.data.data;
            },function(err){
                that.pushlist = []
                that.$alert(err, { title: "错误" });
            })
            that.newsquerypar.speid = that.itemedit.spe_id;
            that.newsquerypar.bdate = that.itemedit.new_bdate;
            that.newsquerypar.edate = that.itemedit.new_edate;
            that.newsquerypar.keywords = that.itemedit.spe_keywords;

            this.dialogFormVisible = true;
        },
        newsquery(){//系统内搜索材料
            let that = this
            that.newsquerypar.bdate = that.FormatDate(that.newsquerypar.bdate)
            that.newsquerypar.edate = that.FormatDate(that.newsquerypar.edate)
            that.PostData("Spe/newsQuery", that.newsquerypar, function (res) {
                that.newsquerylist = res.data.data;
            }, function (err) {
                that.newsquerylist=[]
                that.$alert(err, { title: "错误" });
            });
        },
        newsexists(fileid,lists){//判断是否已经选择
            let yn =false;
            lists.forEach((item,index)=>{
                if(item.file_id == fileid){
                    yn = true
                }
            })
            return yn;
        },
        pushchk(item,chk){//选择文件
            // let domode = "选取"
            // if(!chk){
            //     domode = "去除"   
            // }
            let that = this;
            // that.$confirm("确定要"+domode+"当前图片吗？", "询问", {
            //     confirmButtonText: "确定",
            //     cancelButtonText: "取消",
            //     type: "warning",
            // }).then(() => {
                if(chk){
                    let pushitem = Object.assign({}, item);
                    pushitem.spep_id = that.GUID()
                    pushitem.spep_date=''
                    pushitem.spe_id = that.itemedit.spe_id;
                    pushitem.new_id = that.news.new_id;
                    pushitem.new_title = that.news.new_title;
                    pushitem.unit_id = that.news.unit_id;
                    pushitem.unit_name = that.news.unit_name;
                    that.newspushs.push(pushitem);
                    item.pushed = true;
                }
                else{
                    item.pushed = false;
                    that.newspushs.forEach((citem,cindex)=>{
                        if(citem.file_id == item.file_id){
                            that.newspushs.splice(cindex,1);
                        }
                    })
                }
            // })
            // .catch(() => { });
        },
        DelPush(item,index){//删除报送
            console.log(item)
            let that = this
            that.$confirm("确定要去掉当前选取的材料吗？", "询问", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                that.GetData('Spe/SpeNewsDelPushs',{speid:item.spe_id,newid:item.new_id},function(res){
                    that.pushlist.splice(index,1)
                },function(err){
                    that.$alert(err, { title: "错误" });
                })
            }).catch(()=>{})
        },
        PostPush(){//提交报送
            let that = this;
            if(that.newspushs.length<1){
                that.$alert('请选取图片！', { title: "错误" });
                return;
            }            
            that.$confirm("确定要报送当前选取的图片吗？", "询问", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                let par = {speid:that.itemedit.spe_id,newid:that.news.new_id,sts:that.newspushs}
                console.log(par)
                that.PostData('Spe/SpeNewsSetPushs',par,function(res){
                    that.dialogFormVisible4 = false;
                    that.newsfilesclosed();
                },function(err){
                    that.$alert(err, { title: "错误" });
                })
            }).catch(()=>{})
        },
        changefiles(newid,newtitle,unitid,unitname,state){//查看材料图片列表、材料详情
            let that = this
            that.activeName1 = "图片列表";
            that.newsstate = state
            that.news.new_id = newid;
            that.news.new_title = newtitle
            that.news.unit_id = unitid;
            that.news.unit_name = unitname
            that.GetData('Spe/SpeNewsPics',{newid:newid,speid:that.itemedit.spe_id},function(res){
                console.log(res)
                that.newsfiles = res.data.data;
                that.newspushs = res.data.pushs;
                that.newstakeins = res.data.takeins;
                that.newsfiles.forEach((item,index)=>{
                    if(that.newsexists(item.file_id,that.newspushs))
                        item.pushed = true
                    else
                        item.pushed = false
                })
            },function(err){
                that.newsfiles =[]
                that.newspushs = []
                that.$alert(err, { title: "错误" });
            })
            that.dialogFormVisible4 = true;
        },
        newsfilesclosed() {
            let that = this
            switch (that.newsstate) {//2：从单位报送材料打开，3：从系统查找材料打开
                case 3:
                    that.newsquery()
                    break;
            }
            that.GetData('Spe/SpePushList',{speid:that.itemedit.spe_id,selectmode:3},function(res){
                that.pushlist = res.data.data;
            },function(err){
                that.pushlist = []
                that.$alert(err, { title: "错误" });
            })
            that.getmainlist()
        }
    }
}
</script>


<style scoped lang="less">
.pagelist {
    width: 100%;
    height: 380px;
    font-size:13px;
    // border-left: 1px solid #EBEEF5;
    // border-right: 1px solid #EBEEF5;
    // border-bottom: 1px solid #EBEEF5;
    overflow: auto;
    display: flex;
    flex-wrap: wrap;

    .listitem {
        cursor: pointer;
        width: 150px;
        height: 250px;
        margin: 5px;
        border: 1px solid #EBEEF5;
        border-radius: 3px;
        box-shadow: 5px 5px 2px #EBEEF5;
        position: relative;
        text-align: center;

        img {
            width: 130px;
            height: 130px;
        }

        .deleteitem {
            position: absolute;
            top: 0px;
            right: 0px;

        }

        .countitem {
            position: absolute;
            top: 0px;
            left: 0px;            
            display: inline-block;
            text-align: center;
            white-space: nowrap;
            
            .countitem1{
                background-color: #F56C6C;
                color: #FFF;
                height: 18px;
                line-height: 18px;
                padding: 0 6px;
                font-size: 12px;
                border: 1px solid #FFF;
            }
            .countitem2 {
                //left: 20px;
                background-color: #b1afaf;
                color: #FFF;  
                height: 18px;
                line-height: 18px;
                padding: 0 6px;
                font-size: 12px;
                border: 1px solid #FFF;          
            }
        }
    }
}</style>
    